import { formatDate } from 'lib/helpers/dateUtils';
import { Capitalize, iaRa, mString } from 'lib/helpers/utility';
import { TYPE_LABELS } from 'lib/constants/transaction/typeLabels';

import {
  DATE_MEDIUM,
  DATE_SHORT,
  DATE_TIME_MEDIUM
} from 'components/shared/DocumentSheet/lib/docFormats';

import { maskCardNumber } from './cardMask';

export const getPaymentMethodLabel = (type) =>
  type ? (TYPE_LABELS[type] ?? Capitalize(type)) : '';

export const getPaymentMethodValue = (transaction) => {
  const checkNumber = transaction?.check_number;
  const reference = checkNumber ? `#${checkNumber}` : maskCardNumber(transaction?.cc_number);

  return [getPaymentMethodLabel(transaction?.type), reference].filter(Boolean).join(' ');
};

export const getAppliedTo = (transactions, timezone) => {
  const dates = [
    ...new Set(
      iaRa(transactions)
        .map((transaction) => formatDate(transaction?.date_of_service, timezone, DATE_SHORT))
        .filter(Boolean)
    )
  ];

  if (!dates.length) return '';

  const label = dates.length > 1 ? 'Visits' : 'Visit';
  const joined = dates.length === 2 ? dates.join(' & ') : dates.join(', ');

  return `${label} ${joined}`;
};

export const buildDetailEntries = ({ patient, payer, transaction, transactions, timezone }) => {
  const appliedTo = getAppliedTo(transactions, timezone);

  if (payer) {
    return [
      { label: 'Paid by', value: payer?.name },
      { label: 'EOB #', value: payer?.eob_id ? String(payer.eob_id) : '' },
      {
        label: 'Payment date',
        value: payer?.paid_date ? formatDate(payer.paid_date, timezone, DATE_MEDIUM) : ''
      },
      { label: 'Payment method', value: payer?.payment_method },
      { label: 'Check/Trace #', value: payer?.check_number },
      { label: 'Payment ID', value: transaction?.id ? String(transaction.id) : '' },
      { label: 'Applied to', value: appliedTo }
    ];
  }

  return [
    {
      label: 'Patient name',
      value: [patient?.f_name, patient?.l_name].filter(Boolean).join(' ')
    },
    {
      label: 'Patient chart #',
      value: patient?.chart_number || (patient?.id ? String(patient.id) : '')
    },
    {
      label: 'Payment date & time',
      value: transaction?.created_at
        ? formatDate(transaction.created_at, timezone, DATE_TIME_MEDIUM)
        : ''
    },
    { label: 'Payment method', value: getPaymentMethodValue(transaction) },
    { label: 'Payment ID', value: transaction?.id ? String(transaction.id) : '' },
    { label: 'Applied to', value: appliedTo }
  ];
};

export const buildDocLines = ({
  receiptId,
  transaction,
  timezone,
  isCompleted,
  canSeeAmounts,
  amountPaid
}) => {
  const paidOn = transaction?.created_at
    ? formatDate(transaction.created_at, timezone, DATE_MEDIUM)
    : '';

  return [
    [
      receiptId ? { label: 'Receipt ', value: `#${receiptId}` } : null,
      paidOn ? { label: isCompleted ? 'Paid ' : 'Dated ', value: paidOn } : null
    ].filter(Boolean),
    canSeeAmounts && transaction?.id
      ? [
          {
            label: isCompleted ? 'Amount paid ' : 'Amount ',
            value: mString(amountPaid)
          }
        ]
      : []
  ].filter((line) => line.length);
};
